import { Loadable } from "common/Loadable";
import { Overlay } from "common/styleguide/Overlay";
import { Gallery } from "features/gallery/Gallery";
import fetchJSON from "lib/fetchJSON";
import React from "react";

const loadPhotosForGallery = ({ parentType, parentId, limit }) => {
  switch (parentType) {
    case "user":
      return fetchJSON(`/users/${parentId}/photos.json?limit=${limit || 250}`).then(({ photos }) => photos);
    case "route":
    case "trip":
  }
};

// TODO - support readonly=false
const GalleryPropMapping = ({ loadableResources: photos, gallery, onRequestClose, defaultActive }) => (
  <Gallery
    readonly
    photos={photos}
    activePhotoId={defaultActive}
    parentType={gallery.parentType}
    parentId={gallery.parentId}
    onRequestClose={onRequestClose}
  />
);

// legacy bindings hacked onto the old <Gallery /> to use until we get a solid
// url-and-redux based Gallery system in place.
export class GalleryHack extends React.PureComponent {
  render() {
    const { gallery, defaultActive, onRequestClose } = this.props;

    return (
      <Overlay>
        <Loadable
          gallery={gallery}
          onRequestClose={onRequestClose}
          defaultActive={defaultActive}
          component={GalleryPropMapping}
          loadingText="Loading Photos"
          resourceLoaded={() => loadPhotosForGallery(gallery)}
        />
      </Overlay>
    );
  }
}
